// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"Spinner_ldsSpinner__3QtH+"};